import {React, useState, useEffect} from 'react';

import { useNavigate } from 'react-router-dom';


import "@fontsource/mulish"; // Defaults to weight 400.


import CustomerSearchMini from './CustomerSearchMini';

import TextField from '@mui/material/TextField';

import LoadingButton from '@mui/lab/LoadingButton';

import { Label } from '@next-components/label';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from "@fortawesome/pro-regular-svg-icons";

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';


import { makeStyles } from '@mui/styles';

import {getConfigValue} from './Config';



const useStyles = makeStyles(theme => ({
  outermostColumn: {
    fontFamily:'Mulish', 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'flex-start',
    alignItems: 'flex-start',  
    alignSelf: 'center',
    
   },
   maincolumn: {
    fontFamily:'Mulish', 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'flex-start',
    alignItems: 'flex-start',  
    marginTop: '10px',
    backgroundColor: '#F3F3F3',     
    padding: '10px',
    fontSize: 14,
    maxWidth: '420px',
   },
   
   line: {       
     fontFamily:'Mulish', 
     display: 'flex', 
     flexDirection: 'row',      
     justifyContent: 'space-between',
     alignItems: 'center',   
     width: '100%',             
   },

   rowElement: {
    padding: '10px',  
   

   },

   buttonRow: {
    fontFamily:'Mulish', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'flex-end',
    alignItems: 'center',   
    width: '100%',    
    paddingTop: '10px',   
       
   },
   contactColumn: {
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'flex-start', 
    alignItems: 'flex-start',
    alignContent: 'center',
    width: '100%',
    fontSize: 12,
    paddingTop: '10px',
   },

   contactInfoRow: {        
    display:'flex',
    flexDirection: 'row',
    justifyContent:'flex-start',         
    paddingTop: '10px',
    width: '100%',          
    
}, 

contactInfoElement: {          
    flexBasis: '300px',
  
},

button: {          
   
    minWidth: '100px',
  
},

customerSearchButton: {       
    marginLeft: '10px',       
    marginTop: '0px',
},

errorText: {  
    paddingTop: '20px',
    paddingBottom: '20px',
    color: '#FF0000',
    fontWeight: 600,
},  
successText: {
  paddingTop: '20px',
  paddingBottom: '20px',
  color: '#1BB0A9',
  fontWeight: 600,


},

nobreakingText: {
  whiteSpace: 'nowrap',
},

usersList: {
  overflow: 'auto',
  maxHeight: 150,
},
outerContactsRow: {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    alignItems: 'flex-start',
    alignContent: 'center',
    width: '100%',
    fontSize: 12,
    // backgroundColor: 'lightgray',
    
},
sendButtonColumn: {
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'space-around', 
    alignItems: 'flex-start',
    alignContent: 'center',
    padding: '2px',
    height:'120px',
   

}


}));








function Login(props) {
  const [accountNo, setAccountNo] = useState('');
  const [invoiceNo, setInvoiceNo] = useState('');
  const [showEmailAndPhone, setShowEmailAndPhone] = useState(false);  
  //const [searchBtnIsLoading, setSearchBtnIsLoading] = useState(false);
  const [sessionToken, setSessionToken] = useState();
  const [sentPinEmail, setSentPinEmail] = useState(false);
  const [sentPinSms, setSentPinSms] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [pin, setPin] = useState(); 
  
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState();

  const [searchObject, setSearchObject] = useState({});

  const [loadingButtons, setLoadingButtons] = useState({});

  var store = require('store')

  const navigate = useNavigate();  
    

    const isLoading = (buttonName) => {
        return loadingButtons[buttonName];
    }

    const setLoading =(buttonName, isLoading) => {
        var ldnButtons = {...loadingButtons};
        ldnButtons[buttonName] = isLoading;
        setLoadingButtons(ldnButtons);        
    }

  let token = store.get("sessionToken");
  if (sessionToken!=token)
    setSessionToken(token);
  

  const onAccountNoChange = (text) => {    
    console.log("set", text);   
    setAccountNo(text);    
  }

  const onInvoiceNoChange = (text) => {       
    setInvoiceNo(text);
  }   

  const handleOK = () => {   
    fetchItems();
   
  };
  const onPinChange = (p) => {       
    setPin(p);    
  }  

  const sendEmailOrSms = async (isEmail) => {   
    setErrorMessage(null);

    var emailOrSmsId;

    if (isEmail) {
      setLoading("sendEmail", true);
      emailOrSmsId = selectedContact.EmailId;
    }
    else {
      setLoading("sendSms", true);
      emailOrSmsId = selectedContact.MobilePhoneId;
    }
    
    const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Home/sendPinEmailOrSms/${sessionToken}/${emailOrSmsId}`);      
    const json = await res.json();  
    if (json["result"]=="success") {
        if (isEmail)
          setSentPinEmail(true);
        else
          setSentPinSms(true);

        console.log("pin sent");
    }
    else if (json["errorCode"]=='110'){
        setErrorMessage(`PIN er allerede sent til dette nummeret/epost-adressen. Vennligst kontroller at det oppførte nummeret/epost-adressen er korrekt, 
            i motsatt fall ta kontakt med kundeservice. Dersom det er korrekt og du ikke snarlig mottar PIN, forsøk å sende på nytt om ${json["waitTime"]} minutter.`)
    }
    console.log(json);
    setLoading("sendEmail", false);
    setLoading("sendSms", false);
  };

  
  

  const LogInWithPin = async () => {   
    setErrorMessage(null);

    setLoading('submitPin', true);

    if (pin == null){
      setErrorMessage("Vennligst oppgi  PIN");
      return; 
    }

    const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Home/LogInWithPin/${sessionToken}/${pin}`);  
    const json = await res.json();
    if (json["result"]=="success") {
      console.log("log in successful");        
      props.checkLoginStatus();
    }
    else if (json["errorCode"]=='220'){
        setErrorMessage(`PIN har feil format, vennligst bruk kun tall.`)
    }
    else if (json["errorCode"]=='225'){
      setErrorMessage(`Lag PIN ved å be om tilsending på epost eller sms.`)
    }
    else if (json["errorCode"]=='200'){
      setErrorMessage(`PIN er utløpt på tid, vennligst be om å få tilsendt ny PIN.`)
    }
    else if (json["errorCode"]=='210'){
      setErrorMessage(`PIN er tastet feil for mange ganger, vennligst be om å få tilsendt ny PIN.`)
    }
    else if (json["errorCode"]=='230'){
      setErrorMessage(`Inkorrekt PIN, vennligst kontroller at du har oppgitt PIN tilsendt på epost / SMS.`)
    }
    console.log(json);

    setLoading('submitPin', false);
  };
  
    
  
  const classes = useStyles();


  

  const fetchItems = async () => {       
    
    
    //reset
    setErrorMessage(null);    
    setSentPinSms(false);
    setSentPinEmail(false);


    setLoading("search", true);
        
    const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Home/getObfuscatedCustomerData/${store.get("sessionToken")}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.          
        headers: {
          'Content-Type': 'application/json'             
        },            
        body: JSON.stringify(searchObject) // body data type must match "Content-Type" header
    });
    
    const json = await res.json(); 
    
    if (json["result"]=='success') {      
        setShowEmailAndPhone(true);
        setContacts(json.contacts);
        
    }
    else if (json["errorCode"]=='400'){
        setShowEmailAndPhone(false); 
        setErrorMessage("Kunde ikke funnet. Vennligst sjekk ditt kundenummer på din faktura.");
    }
    else if (json["errorCode"]=='401'){
      setShowEmailAndPhone(false); 
      setErrorMessage("Ingen kontaktinformasjon for denne kunden ble funnet. Vennligst kontakt kundeservice.");
  }

    console.log(json);
    
    setLoading("search", false);
}

const handleListItemClick = (contact) => {
    setSelectedContact(contact);


}

const getContactEmailAndPhoneString = (contact) => {
  var displayString = "";
  if (contact) {
    if (contact.Email)
      displayString="Email: " + contact.Email;
    if (contact.MobilePhone)
      displayString = displayString + "  " + "Mobile: " + contact.MobilePhone;
  }

  return displayString;

}


  return (  

    
    <div className={classes.outermostColumn} width='100%'>

             
        <div className={classes.maincolumn}>
          <Label title='Logg Inn' value='Vennligst oppgi kundenummer eller fakturanummer'/>           
            
          <CustomerSearchMini onIdSearchObjectChange={setSearchObject}/>
          <div className={classes.customerSearchButton}> 
                    <LoadingButton variant="contained" size='small' color="primary" loading={isLoading('search')} 
                        onClick={handleOK}>Ok
                    </LoadingButton> 
          </div>   

         
                                                                
        </div>


            {showEmailAndPhone && 
            
                <div className={classes.maincolumn}>
                    <p>
                    For at vi skal kunne logge deg inn på en sikker måte trenger vi å sende deg en PIN-kode på epost eller sms. 
                    Vennligst velg din kontaktinformasjon under og klikk på knappen for utsending av PIN.
                    </p>

                    Registrerte kontakter
                    <div className={classes.outerContactsRow}> 
                      <List className={classes.usersList} dense={true}>
                          {contacts.map((item,index) => 
                              <ListItem selected={item===selectedContact} onClick={() => handleListItemClick(item)}>
                                  <ListItemIcon>
                                      <FontAwesomeIcon icon={faUser} />
                                  </ListItemIcon>
                                  <ListItemText
                                      primary={item.Email && 'Epost: ' + item.Email}
                                      secondary={item.MobilePhone && 'Mobil: ' + item.MobilePhone}
                                  />
                                 
                              </ListItem>
                          )}               
                      </List>

                      
                      <div className={classes.sendButtonColumn}>                       
                        <LoadingButton disabled={!selectedContact ||!selectedContact.Email} loading={isLoading('sendEmail')} style={{width:'80px'}} variant="contained" size='small' color="primary" onClick={_=>sendEmailOrSms(true)}>Send på epost </LoadingButton>                                
                        <LoadingButton disabled={!selectedContact ||!selectedContact.MobilePhone} loading={isLoading('sendSms')} style={{width:'80px'}}variant="contained" size='small' color="primary" onClick={_=>sendEmailOrSms(false)}>Send på SMS </LoadingButton>         
                      </div>

                    </div>  

                    

                    {sentPinEmail && <div className={classes.successText}>PIN-kode er nå sendt på epost.</div>}
                    {sentPinSms && <div className={classes.successText}>PIN-kode er nå sendt på SMS.</div>}
                                  
                </div>

            }


        

        {showEmailAndPhone && 
            <div className={classes.maincolumn}>
                <Label title='PIN-Kode' value='Vennligst skriv inn engangs-PIN dersom du har mottatt denne på epost eller SMS.'/>                      
                <div className={classes.line}>                    
                    <TextField onChange={e => onPinChange(e.target.value)}  
                        variant="outlined" label="PIN" size='small'>
                    </TextField> 
                    <LoadingButton className={classes.customerSearchButton} loading={isLoading('submitPin')} variant="contained" size='small' color="primary" onClick={LogInWithPin}>Send PIN </LoadingButton>        
                </div>
            </div>
        }

        {errorMessage && 
          <div className={classes.maincolumn}>
            <div className={classes.errorText}>{errorMessage}</div>
          </div>
        }


    </div>

  );
}




export default Login;
